import OrderService from "../../services/OrderService";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";

import AuthService from "../../services/AuthService";
import {AxiosError} from "axios";

export const useEvent = (eventId: number) => {
	const history = useHistory();

	const handleCheckout = () => {
		const cartId = sessionStorage.getItem('cartId');
		if (!cartId) return;
		const userId = AuthService.readUserData()?.id || '';
		OrderService.reserve(cartId, userId, eventId, 'WEB')
			.then((response) => {
				const { reservationId } = response.data;
				history.push({ pathname: `/inscricao/${reservationId}`, state: { eventId } });
				sessionStorage.removeItem('cartId');
				sessionStorage.removeItem('cartStartTime');
			})
			.catch((error: any) => {
				const axiosError = error as AxiosError<{ message?: string; detail?: string }>;
				const errorMessage = axiosError.response?.data?.detail
					?? axiosError.response?.data?.message
					?? 'Algo deu errado...';
				toast(errorMessage, { type: toast.TYPE.ERROR });
				window.dispatchEvent(new CustomEvent('__SEATS_MAP_CHECKOUT_ERROR_EVENT__'));
				throw error;
			})
	}

	return {
		handleCheckout
	}
}
